import {
  // injectable,
  IPageSetupResource,
  PreloadModuleInfo,
} from '@meego-remote/core/app/contract';

// @injectable()
export class DetailPageSetupResource extends IPageSetupResource {
  pageKey = 'MainView';
  
  getPreloadModuleFast() {
    console.log('MainView getPreloadModuleFast FAST');
    // return require('./output.json');
    return [];
  }

  async getPreloadModule(): Promise<PreloadModuleInfo[]> {
    return []
  }
}
